// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__I8YNa","logo":"NavBar_logo__c0klG","buttons":"NavBar_buttons__kRU2x","currentPag":"NavBar_currentPag__PvGPs","userContainer":"NavBar_userContainer__bnbVL"};